/*
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:50
 * @LastEditTime: 2019-09-24 10:30:21
 * @Version: 1.0
 * @Description: 入口js
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'babel-polyfill' //  补丁

import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-ui.scss'

import VueAMap from 'vue-amap'
import './styles/global.scss'
// import '../public/index.css'
import 'normalize.css'
import 'animate.css'

// 富文本编辑器样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import VueFullpage from 'vue-fullpage.js/dist/vue-fullpage'
import 'vue-fullpage/vue-fullpage.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import echarts from 'echarts'
import 'babel-polyfill'
import china from 'echarts/map/json/china'
import filters from './filters'
import validate from '@/utils/validate' // 表单验证

import { character } from '@/utils/validate' // 中文字节长度表单验证
// 公共指令
import { Directives } from '@/shared/directives/index.js'
// 公共管道
import { Filters } from '@/shared/filters/index.js'
// import './utils/directives.js'

import '@/permission'
// 图片放大
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)

// 打印
import Print from 'vue-print-nb'
Vue.use(Print)

// 权限指令
import permission from './directives/permission'
Vue.use(permission)

//  输入框限制指令
import directives from './directives/validation'
Vue.use(directives)

// 上传组件
import components from '@/components'
Vue.use(components)

// 添加全局指令
Vue.use(Directives)
Vue.use(Filters)

// 自定义指令
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

Vue.prototype.$validate = validate // 挂载到Vue原型上
Vue.prototype.$character = character // 挂载到Vue原型上
Vue.prototype.$echarts = echarts
echarts.registerMap('china', china)

Vue.use(VueAwesomeSwiper)
Vue.use(VueFullpage)
Vue.config.productionTip = false
Vue.use(elementUI)

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '7e56829333dfee64f1bdc71860efb86a',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.DistrictSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Driving'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.15',
  uiVersion: '1.0.11',
  extData: { 'a': 1 }
})

Vue.directive('dialogDrag',{
  bind(el,binding,vnode){
    console.log(el);
  }
})




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

